import { DirtyFormPrompt } from "@components/common/DirtyFormPrompt";
import React from "react";
var RowForm = function (props) {
    var children = props.children;
    return (React.createElement("tr", null,
        React.createElement(DirtyFormPrompt, null),
        children));
};
export default RowForm;
